import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Button } from '@cubeyou-team/hx-react-components';

import {
  addApplicationTab,
  removeAllApplicationDroppingEntities,
  showCompareAudienceModal,
} from '../../../actions';
import { APPS_MAP } from '../../../constants/config';

const StyledAudienceCompareOpenerMainAction = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: visible;
`;

const StyledAudienceCompareOpenerFooter = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0.5rem;
  position: absolute;
  bottom: 0;
  width: 100%;
  pointer-events: visible;
`;

const CompareAudienceOpenerActions = ({ entities }) => {
  const dispatch = useDispatch();
  const isNotTouched = entities.every(entity => entity.fromCompare);
  return (
    <>
      <StyledAudienceCompareOpenerMainAction>
        <Button
          variant="primary"
          size="small"
          icon="add"
          disabled={entities.length === 3}
          onClick={e => {
            e.stopPropagation();
            dispatch(showCompareAudienceModal());
          }}
        >
          new interest
        </Button>
      </StyledAudienceCompareOpenerMainAction>
      <StyledAudienceCompareOpenerFooter>
        <Button
          size="small"
          id="btnCancel"
          variant="outlined"
          onClick={e => {
            e.stopPropagation();
            dispatch(removeAllApplicationDroppingEntities(APPS_MAP.COMPARE));
          }}
        >
          cancel
        </Button>
        <Button
          size="small"
          variant="secondary"
          disabled={entities.length < 2 || isNotTouched}
          onClick={e => {
            e.stopPropagation();
            dispatch(removeAllApplicationDroppingEntities(APPS_MAP.COMPARE));
            dispatch(addApplicationTab([...entities], APPS_MAP.COMPARE));
          }}
        >
          compare
        </Button>
      </StyledAudienceCompareOpenerFooter>
    </>
  );
};
export default CompareAudienceOpenerActions;
